import React, { useState } from "react";
import {
  Box, Button, Typography, CircularProgress, Alert, Paper
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState(null);

  async function handleLogin() {
    setLoading(true);
    setErrore(null);
    try {
      await login();
      navigate("/");
    } catch (error) {
      if (error.message?.includes("Accesso consentito solo")) {
        setErrore("Dominio non autorizzato ad accedere a questo strumento");
      } else {
        setErrore("Errore durante il login. Riprova.");
      }
    }
    setLoading(false);
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ backgroundColor: "#f0f4ff" }}
    >
      <Paper elevation={3} sx={{ p: 5, maxWidth: 420, width: "100%", textAlign: "center" }}>
        {/* Logo */}
        <Box mb={3}>
          <svg width="180" viewBox="0 0 200 100" role="img">
            <defs>
              <linearGradient id="lgGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%"   stopColor="#E63329"/>
                <stop offset="50%"  stopColor="#9B2DB5"/>
                <stop offset="100%" stopColor="#1A56A0"/>
              </linearGradient>
              <linearGradient id="lgBarGrad" x1="0%" y1="100%" x2="0%" y2="0%">
                <stop offset="0%"   stopColor="#ffffff" stopOpacity="0.4"/>
                <stop offset="100%" stopColor="#ffffff" stopOpacity="0.95"/>
              </linearGradient>
            </defs>
            <rect x="4" y="4" width="60" height="60" rx="10" fill="url(#lgGrad)"/>
            <rect x="18" y="0" width="5" height="10" rx="2.5" fill="#ffffff" opacity="0.9"/>
            <rect x="44" y="0" width="5" height="10" rx="2.5" fill="#ffffff" opacity="0.9"/>
            <rect x="10" y="38" width="6" height="18" rx="2" fill="url(#lgBarGrad)"/>
            <rect x="20" y="30" width="6" height="26" rx="2" fill="url(#lgBarGrad)"/>
            <rect x="30" y="22" width="6" height="34" rx="2" fill="url(#lgBarGrad)"/>
            <rect x="40" y="28" width="6" height="28" rx="2" fill="url(#lgBarGrad)"/>
            <rect x="50" y="16" width="6" height="40" rx="2" fill="url(#lgBarGrad)"/>
            <polyline points="13,38 23,30 33,22 43,28 53,16"
              fill="none" stroke="#F59E0B" strokeWidth="1.5"
              strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="53" cy="16" r="2.5" fill="#F59E0B"/>
            <text x="74" y="22" fontFamily="sans-serif" fontSize="11" fontWeight="600" fill="#1A56A0">Dashboard</text>
            <text x="74" y="36" fontFamily="sans-serif" fontSize="11" fontWeight="600" fill="#1A56A0">Gestione</text>
            <text x="74" y="50" fontFamily="sans-serif" fontSize="11" fontWeight="600" fill="#1A56A0">Eventi</text>
            <line x1="4" y1="74" x2="196" y2="74" stroke="#e0e0e0" strokeWidth="1"/>
            <text x="100" y="88" textAnchor="middle"
              fontFamily="sans-serif" fontSize="8.5"
              fill="#888888" letterSpacing="1">
              Virtual Meeting Assistant
            </text>
          </svg>
        </Box>

        <Typography variant="h6" fontWeight="bold" mb={1} color="text.primary">
          Accedi al tuo account
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Utilizza il tuo account Google Workspace Algores
        </Typography>

        {errore && (
          <Alert severity="error" sx={{ mb: 3, textAlign: "left" }}>
            {errore}
          </Alert>
        )}

        <Button
          fullWidth
          variant="contained"
          size="large"
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <GoogleIcon />}
          onClick={handleLogin}
          disabled={loading}
          sx={{
            backgroundColor: "#1A56A0",
            "&:hover": { backgroundColor: "#1344880" },
            py: 1.5,
          }}
        >
          {loading ? "Accesso in corso..." : "Accedi con Google"}
        </Button>
      </Paper>
    </Box>
  );
}